const permissions = {
  CustomerManagement: {
    view: "View User",
    create: "Create User",
    update: "Update User",
    reactive: "Reactive User",
    deactive: "Deactive User",
    delete: "Delete User",
    createComment: "Create User Comment",
    updateComment: "Update User Comment",
    deleteComment: "Delete User Comment",
    exportData: "Export User",
  },
  RoleAndPermissionManagement: {
    view: "View Role",
    create: "Create Role",
    update: "Update Role",
    delete: "Delete Role",
    viewPermission: "View Permission",
  },
  AdminUserManagement: {
view: "View User",
    create: "Create User",
    update: "Update User",
    reactive: "Reactive User",
    deactive: "Deactive User",
    delete: "Delete User",
    createComment: "Create User Comment",
    updateComment: "Update User Comment",
    deleteComment: "Delete User Comment",
    exportData: "Export User",
  },
  Brand: {
    view: "View Brand",
    create: "Create Brand",
    update: "Update Brand",
    delete: "Delete Brand",
    exportData: "Export Brand",
  },
};

export default permissions;
